import axios from "axios";
import { toast } from "react-toastify";
export const GetAllMaintenence = (data) => {
  return {
    type: "get_allMaintenence",
    payload: data,
    loader: false,
  };
};
export function getallMaintenence() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Maintenance/GetAll`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllMaintenence(result.data.MaintenanceDetail));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
